import { cn } from "@babybjorn/ui";
import { AnimatePresence } from "motion/react";
import type { FC, HTMLAttributes, PropsWithChildren } from "react";
import * as s from "./AccordionItem.module.scss";

type AccordionItemProps = PropsWithChildren<
	HTMLAttributes<HTMLDivElement> & {
		variant: "primary" | "inverted" | "filter";
		rounded?: boolean;
	}
>;

const AccordionItem: FC<AccordionItemProps> = ({
	variant = "primary",
	rounded = false,
	children,
	...rest
}) => {
	return (
		<section
			className={cn(
				s.container,
				variant === "filter" ? undefined : s[variant],
				{ [s.rounded]: rounded },
			)}
			{...rest}
		>
			<AnimatePresence>
				<>{children}</>
			</AnimatePresence>
		</section>
	);
};

export default AccordionItem;
